module.exports = __webpack_public_path__ + "static/media/texfel.0166ab25.png";